import { CarePlanState } from '@seen/core/models/care-plans/constants'
import type { BadgeProps } from '@seen/ui'

export const carePlanStateColors: Record<CarePlanState, BadgeProps['color']> = {
  [CarePlanState.Active]: 'blue',
  [CarePlanState.Draft]: 'yellow',
  [CarePlanState.PendingSignatures]: 'orange',
  [CarePlanState.SignedOff]: 'green',
  [CarePlanState.Closed]: 'gray',
  [CarePlanState.Deleted]: 'red',
  [CarePlanState.Unknown]: 'gray',
  [CarePlanState.Voided]: 'gray',
}
